var React = require('react');

function Add (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17.5,0A17.51,17.51,0,1,0,29.87,5.13,17.52,17.52,0,0,0,17.5,0Zm0,33a15.57,15.57,0,1,1,11-4.56A15.47,15.47,0,0,1,17.5,33Z","transform":"translate(0)","key":0}),React.createElement("path",{"d":"M18.33,10.9H16.67v5.77H10.9v1.66h5.77V24.1h1.66V18.33H24.1V16.67H18.33Z","transform":"translate(0)","key":1})]);
}

Add.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 35 35"};

module.exports = Add;

Add.default = Add;
